"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateUpgradeProduct = void 0;

var _validateProperty = require("ui-addon-upgrades/_core/common/data/upgradeData/validators/validateProperty");

var _upgradeProducts = require("ui-addon-upgrades/_core/common/data/upgradeData/properties/upgradeProducts");

var validateUpgradeProduct = function validateUpgradeProduct(upgradeProduct) {
  var isValidUpgradeProduct = _upgradeProducts.upgradeProductValues.indexOf(upgradeProduct) !== -1;
  return (0, _validateProperty.validateProperty)(isValidUpgradeProduct, "expected upgradeProduct to be one of " + _upgradeProducts.upgradeProductValues + " but got " + upgradeProduct, 'upgradeProduct');
};

exports.validateUpgradeProduct = validateUpgradeProduct;